var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"p2p-post-grid"},[_vm._t("default",null,{"cell":_vm.cell})],2)}
var staticRenderFns = []

export { render, staticRenderFns }